export { default } from './PhoneNumberWithRedirectQuizStep';
